const publishDestinationEditorTabs = {
  SETTINGS: 'settings',
  PRIVACY:  'privacy',
  CODE:     'code',
  LAUNCH:   'launch',
};
publishDestinationEditorTabs.ALL = _.values(publishDestinationEditorTabs);

export default publishDestinationEditorTabs;
